import React, { Component } from 'react';
import PresetMenuBar from './PresetMenuBar';
import PresetScroll from './PresetScroll';
import axios from 'axios';
import cookie from 'react-cookies';
import Config from './Configs/criteria.json';

const debounce = (fn, delay) => {
    let timer = null;
    return function (...args) {
        const context = this;
        timer && clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(context, args);
        }, delay);
    };
}
const CancelToken = axios.CancelToken;
let cancel;

export default class PresetWidget extends Component {
    constructor(props) {
        super(props);

        let presetscreener = [];
        for (let i=0; i<Config.presetscreener.maxnum; i++) {
            presetscreener[i] = { name: "", count: "", criteria: {},sortby:"",sortorder:""};
        }
//"preset"
        this.state = {
            presetscreener,
        };

        this.getPresetResult = debounce(this.getPresetResult, 500);
    }
    handleMenuChange = (section) => {
        this.props.handleSection(section);
        this.props.handlePresetArrow(false);
        this.props.handleScrollXPosChange(0);
    }
    handleScrollXPosChange = (scrollXPos) => {
        this.props.handleScrollXPosChange(scrollXPos);
    }
    handleLoadPreset = (num) => {
        // console.log("PresetWidget:"+num);
        this.getPresetResult(num+1);
        this.props.onLoad(this.state.presetscreener[num].criteria,"p0"+(num+1),this.state.presetscreener[num].sortby,this.state.presetscreener[num].sortorder);
    }
    handleLoadCustom = (num) => {
        this.props.onLoadCustom(num,"c0"+(num+1));
    }
    getPresetResult = (num) => {
        cancel && cancel();
        axios.get("data/screenerpreset", {
            params: {
                token: this.props.token
            },
            cancelToken: new CancelToken((c) => {
                cancel = c;
            })
        })
        .then(
            (result) => {
                if (result.data) {
                    let presetscreener = [];
                    for (let i=0; i<result.data.length; i++) {
                        presetscreener[i] = {
                            name: result.data[i].name,
                            count: result.data[i].count,
                            criteria: result.data[i].cs,
                            description: result.data[i].description,
                            sortby:result.data[i].sortby?result.data[i].sortby:"c",
                            sortorder:result.data[i].sortorder?result.data[i].sortorder:"asc"
                        }
                    }
                    this.setState({ presetscreener });
                    if(num>0){return;}
                    if(this.props.default >4){
                        this.props.handlePresetArrow(true);
                        this.handleScrollXPosChange(-(238*2-22));
                    }
                    if(this.props.default||num>0){
                        this.props.onLoad(presetscreener[(this.props.default-1)?(this.props.default-1):0].criteria,"p0"+((this.props.default-1)?(this.props.default-1)+1:0+1));
                    }else{
                        this.props.clearAll("preset");
                    }
                    
                }
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
            }
        )
    }
    componentDidMount() {
        this.getPresetResult();
    }
    handleArrowSelected=(selected)=>{
        this.props.handlePresetArrow(selected);
        // this.setState({leftArrowSelected:selected});
    }

    render() {
        return (
            <div className="PresetWidget">
                <PresetMenuBar section={this.props.section} onMenuChange={this.handleMenuChange} />
                <PresetScroll clearAll={this.props.clearAll} section={this.props.section} scrollXPos={this.props.scrollXPos} onScrollXPosChange={this.handleScrollXPosChange} onLoadPreset={this.handleLoadPreset} onLoadCustom={this.handleLoadCustom} preset={this.state.presetscreener} data={this.props.data} data2={this.props.data2} presetSelected={this.props.presetSelected} leftArrowSelected={this.props.leftArrowSelected} handleArrowSelected={this.handleArrowSelected}/>
            </div>
        )
    }
}